/**
 * UserPreferencesRepository defines the interface for user preferences persistence.
 *
 * @typedef {import('../../domain/UserPreferences').default} UserPreferences
 */
class UserPreferencesRepository {
  /**
   * @returns {Promise<UserPreferences>}
   */
  // eslint-disable-next-line class-methods-use-this
  getUserPreferences() {
    throw new Error('UserPreferencesRepository.getUserPreferences is not implemented');
  }

  /**
   * @param {UserPreferences} userPreferences
   * @returns {Promise<UserPreferences>}
   */
  // eslint-disable-next-line class-methods-use-this, no-unused-vars
  updateUserPreferences(userPreferences) {
    throw new Error('UserPreferencesRepository.updateUserPreferences is not implemented');
  }
}

export default UserPreferencesRepository;
